export const promptGuide = {
  intro:
    "The prompt defines your bot's personality, knowledge, and behavior. Write clear instructions about:",
  bullets: [
    "Who the bot is (role, personality, tone)",
    "What the bot knows (expertise, domain knowledge)",
    "How the bot should respond (style, format, limitations)",
    "Any specific rules or guidelines to follow",
  ],
  important:
    'Don\'t include time-sensitive tasks or recurring actions (like "send daily reports" or "remind me every week").',
  closing:
    "Be specific and detailed - the more context you provide, the better your bot will perform.",
} as const;

export const promptSecurityNote =
  "Never include passwords, API keys, or sensitive information in your bot's prompt. The prompt and all bot actions should be considered potentially accessible to others. Only include information you're comfortable sharing publicly." as const;
